import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { setCustomerAsync } from "../../Actions/CustomerAsyncActions";
import { useAppDispatch } from "../../storeHooks";
export const Customer = ({ data, onDelete }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const selectCustomer = (customer) => {
        dispatch(setCustomerAsync(customer));
        navigate("/dashboard");
    };
    const showModal = () => {
        setShowDeleteModal(true);
    };
    const closeModal = () => {
        setShowDeleteModal(false);
    };
    const confirmDelete = (customerId) => {
        if (onDelete) {
            onDelete(customerId);
        }
        setShowDeleteModal(false);
    };
    return (_jsxs("li", { children: [_jsx("div", { className: "info", children: _jsxs("button", { onClick: () => selectCustomer(data), children: [data.id, _jsx("span", { className: "name", children: data.name })] }) }), _jsxs("div", { className: "button-wrapper", children: [_jsx("button", { className: "btn btn-secondary", onClick: () => selectCustomer(data), children: t("customer.buttons.select") }), onDelete ? (_jsx("button", { className: "btn btn-secondary", onClick: showModal, children: t("customer.buttons.delete") })) : null] }), showDeleteModal ? (_jsx("div", { className: "modal-wrapper", children: _jsxs("dialog", { open: true, onCancel: closeModal, children: [_jsx("h4", { children: t("customer.deleteModal.title", { name: data.name }) }), _jsxs("div", { className: "text-center", children: [_jsx("button", { className: "btn btn-primary", onClick: () => confirmDelete(data.id), children: t("customer.deleteModal.confirm") }), _jsx("button", { className: "btn btn-secondary", onClick: closeModal, children: t("customer.deleteModal.close") })] })] }) })) : null] }));
};
